
import { Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import { Article } from './../ceo-desk.model';

@Component({
    selector: "app-article-card",
    templateUrl: "./article-card.component.html",
})

export class ArticleCardComponent implements OnChanges {

    @Input() article = new  Article();

    @Input() hideDecription:boolean = false;

    isYoutubeVedio : boolean = false

    ngOnChanges(changes: SimpleChanges){
       if(changes.article.currentValue.video){
        this.isYoutubeVedio = changes.article.currentValue.video.startsWith('https://youtu.be/');
       }
    }
  }
  